export const bimbleLightBlue = {
  50: '#f2f9fd',
  100: '#e0f0fb',
  200: '#cee8f8',
  300: '#bce0f6',
  400: '#aad7f3',
  500: '#9ad0f1',
  600: '#74beec',
  700: '#50ade7',
  800: '#2c9ce2',
  900: '#1c87ca',
  A100: '#d2eaf9',
  A200: '#8fcbf0',
  A400: '#1f96e0',
  A700: '#0f4b70',
  contrastDefaultColor: 'light'
}

export const bimbleDarkBlue = {
  50: '#004a6a',
  100: '#004a6a',
  200: '#004a6a',
  300: '#004a6a',
  400: '#004a6a',
  500: '#004B6a',
  600: '#004a6a',
  700: '#004a6a',
  800: '#004a6a',
  900: '#004a6a',
  A100: '#004a6a',
  A200: '#004a6a',
  A400: '#004a6a',
  A700: '#004a6a',
  contrastDefaultColor: 'dark'
}

export const bimbleGrey = {
  50: '#f4f5f5',
  100: '#e5e5e6',
  200: '#d5d6d7',
  300: '#c5c7c9',
  400: '#b5b7ba',
  500: '#a6a8ab',
  600: '#86898d',
  700: '#636569',
  800: '#313335',
  900: '#19191a',
  A100: '#caccce',
  A200: '#96989c',
  A400: '#636569',
  A700: '#313335',
  contrastDefaultColor: 'light'
}



// WEBPACK FOOTER //
// ./src/core/styles/colors.js